import { ReactElement } from 'react'
import { breakpoints } from 'src/theme/breakpoints'
import styled from 'styled-components'
import CategoryNameModal from './LeftPanel/CategoryNameModal'
import DeleteCategoryConfirmation from './LeftPanel/DeleteCategoryConfirmation'
import DeleteListConfirmation from './LeftPanel/DeleteListConfirmation'
import LeftPanel from './LeftPanel/LeftPanel'
import MoveListConfirmation from './LeftPanel/MoveListConfirmation'
import NameListConfirmation from './LeftPanel/NameListConfirmation'
import CartSelectorModal from './RightPanel/CartSelectorModal'
import { DeleteItemsFromListsModal } from './RightPanel/drawers/DeleteItemsFromListsModal'
import { RightPanel } from './RightPanel/RightPanel'

const ListScreen = (): ReactElement => {
  return (
    <Container>
      <LeftPanel />
      <RightPanel />
      <DeleteListConfirmation />
      <NameListConfirmation />
      <MoveListConfirmation />
      <CategoryNameModal />
      <DeleteCategoryConfirmation />
      <DeleteItemsFromListsModal />
      <CartSelectorModal />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px 20px 74px 20px;
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    flex-direction: column;
  }
`

export default ListScreen
